
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';

/**
 * Component that tracks page views when routes change
 * Should be rendered once in the app's root component
 */
const RouteTracker = (): null => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view whenever the location changes
    trackPageView(location.pathname, document.title);
  }, [location]);

  return null;
};

export default RouteTracker;
